<div class="content-block">

  <!-- Content Header (Page header) -->
<!--
  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Articoli </h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Articoli</li>
          </ol>
        </div>
      </div>
    </div>
  </div>-->
  <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Articoli</h2>
                <div class="d-flex gap-4" >
                  <dx-button stylingMode="contained" class="mr-3" text="Nuovo articolo" icon="plus" type="success" (onClick)="goToArticoloNew()"> </dx-button>                  
                </div>
            </div>
        </div>
  </div>


    <div class="card">
      <div class="card-body">
       

            <h3 class="font-bold tracking-tight text-lg"> Filtra per: </h3>
            <app-filtro-button-categorie-articoli [list]="listArticoli" (eventEmitterFilterCategory)="filterGrid($event)" (articoliAttiviEventEmitter)="onArticoliAttiviEventEmitter($event)"></app-filtro-button-categorie-articoli>
        
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <app-grid-archivio-articoli [listArticoli]="listArticoli" [idCategoria]="categoriaRif" [artAttivi]="articoliAttivi"></app-grid-archivio-articoli>
      </div>
    </div> 



</div>